import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { NotFound } from 'components/NotFound/Container/NotFound';
import { useSelector } from 'react-redux';
const GetDynamicMenuPDPComponent = props => {
  const { componentOptions = { web: { pdp: {} } } } = useSelector(data => data.tenantReducer);
  const {
    web: { global },
  } = componentOptions;
  return global?.cateringNavigationAllowed || !props?.isCateringPage ? (
    <LazyLoaderWrapper {...props} testId={props?.testId} importPath='MENU_PDP_DESCRIPTION_PAGE'></LazyLoaderWrapper>
  ) : (
    <NotFound />
  );
};

export default GetDynamicMenuPDPComponent;
